const baseUrl = 'auth';

export const ApiAuth = {
  GenerateAssociation: `${baseUrl}/validate`
};
